exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n\n  .ReportPeriod_component_3anu {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .ReportPeriod_periods_3rZh {\n    display: none;\n  }\n}\n\n.ReportPeriod_periodsTitle_1Bqs {\n  margin-right: 15px;\n\n  display: inline-block;\n\n  width: 90px;\n}\n\n.ReportPeriod_periodsMenu_3RJN {\n  display: inline-block;\n  vertical-align: middle;\n\n  width: calc(100% - 105px);\n}\n\n.ReportPeriod_dates_ZIHi {}\n\n.ReportPeriod_dateGroup_2kI8 {\n  margin-top: 20px;\n\n  display: inline-block;\n}\n\n.ReportPeriod_dateLabel_25Pt {\n  padding-bottom: 10px;\n\n  display: inline-block;\n  vertical-align: bottom;\n\n  width: 15px;\n}\n\n.ReportPeriod_datePicker_13ll {\n  margin: 0 10px;\n}\n\n.ReportPeriod_buttons_2sj9 {}\n\n.ReportPeriod_button_1GDX {\n  margin-top: 20px;\n  margin-right: 20px;\n}\n\n.ReportPeriod_periodErrorMessage_1Div {\n  margin-top: 20px;\n\n  max-width: 100%;\n\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ReportPeriod_component_3anu",
	"periods": "ReportPeriod_periods_3rZh",
	"periodsTitle": "ReportPeriod_periodsTitle_1Bqs",
	"periodsMenu": "ReportPeriod_periodsMenu_3RJN",
	"dates": "ReportPeriod_dates_ZIHi",
	"dateGroup": "ReportPeriod_dateGroup_2kI8",
	"dateLabel": "ReportPeriod_dateLabel_25Pt",
	"datePicker": "ReportPeriod_datePicker_13ll",
	"buttons": "ReportPeriod_buttons_2sj9",
	"button": "ReportPeriod_button_1GDX",
	"periodErrorMessage": "ReportPeriod_periodErrorMessage_1Div"
};